import { ModelBase } from "@shoothill/core";
import { NotEquals, ValidateIf } from "class-validator";
import { action, observable } from "mobx";

import { IPlanOfWorkStage, PlanOfWorkStage } from "Globals/Models/Enums/PlanOfWorkStage";
import { PlansOfWorkItemViewModel } from "../Table";

export class AddPlanOfWorkModel extends ModelBase<AddPlanOfWorkModel> {
    // #region Defaults

    public static readonly DEFAULT_PLANOFWORKSTAGES = [];

    public static readonly DEFAULT_PLANOFWORKSTAGE = null;

    public static readonly DEFAULT_PLANOFWORKTOCOPYFROM = null;

    // #endregion Defaults

    // #region Related Properties

    @observable
    public planOfWorkStages = observable<PlanOfWorkStage>(AddPlanOfWorkModel.DEFAULT_PLANOFWORKSTAGES);

    @observable
    public mode: "create" | "copy" = "create";

    // #endregion Related Properties

    // #region Properties

    @observable
    @NotEquals(null, { message: "Please select an option" })
    public planOfWorkStage: PlanOfWorkStage | null = AddPlanOfWorkModel.DEFAULT_PLANOFWORKSTAGE;

    @observable
    @ValidateIf((m) => m.mode === "copy")
    @NotEquals(null, { message: "Please select an option" })
    public planToCopyFrom: PlansOfWorkItemViewModel | null = AddPlanOfWorkModel.DEFAULT_PLANOFWORKTOCOPYFROM;

    // #endregion Properties

    // #region Methods

    @action
    public fromDto(dto: any): void {
        // Plan of Work Stages.
        this.planOfWorkStages.replace(
            dto.map((pows: IPlanOfWorkStage) => {
                const enumType = new PlanOfWorkStage();

                enumType.fromDto(pows);

                return enumType;
            }),
        );
    }

    public toDto(): any {
        return {
            planOfWorkStageId: this.planOfWorkStage?.id,
        };
    }

    // #endregion Methods
}
